import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode';

import { doesCustomerExist } from './customerHelper';

export const customerId = () => {
  const customer = doesCustomerExist();
  if (!customer) {
    return null;
  }
  return jwtDecode(Cookies.get('customerToken')).sub;
};
